import React from 'react';
import { ReviewItem, Reviews, SanityKeyed } from 'types/studio/studio';
import { getTypographyDefaultColor, RatingStars, Typography } from '@ag1/ui';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import clsx from 'clsx';
import styles from './styles.module.scss';

type ReviewsCardProps = SanityKeyed<ReviewItem> & {
  theme: Reviews['theme'];
};

const ReviewsCard = ({
  title,
  text,
  author,
  theme,
  disableRating,
  rating = 0
}: ReviewsCardProps) => (
  <article className={clsx(styles.root, getThemeCSSClass(theme))}>
    <div className={styles.main}>
      {!disableRating && (
        <RatingStars
          rating={rating}
          className={styles.ratingStars}
          childClassName={styles.padding}
          inheritFontSize
          thin
          offset={4}
          theme={theme}
        />
      )}
      {title && (
        <Typography
          component="h3"
          variant="subtitle"
          size="1"
          weight="700"
          color={getTypographyDefaultColor(theme)}
          noPadding
          className={styles.title}>
          {title}
        </Typography>
      )}
      <Typography
        variant="body"
        size="1"
        weight="400"
        color={getTypographyDefaultColor(theme)}
        className={styles.text}
        noPadding>
        {text}
      </Typography>
    </div>
    {author && (
      <Typography
        component="p"
        variant="bodyMono"
        className={styles.monoText}
        size="2"
        weight="400"
        color="grey-1-new"
        noPadding>
        {author}
      </Typography>
    )}
  </article>
);

export default ReviewsCard;
